import React from 'react';
import { motion } from 'framer-motion';
type ButtonProps = {
  children: React.ReactNode;
  href: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'gold' | 'outline';
  ariaLabel?: string;
};
export function Button({
  children,
  href,
  className = '',
  fullWidth,
  variant = 'gold',
  ariaLabel
}: ButtonProps) {
  const external = !href.startsWith('#');
  const styles = variant === 'gold' ? 'bg-gold text-ink shadow-[0_14px_34px_rgba(245,199,75,.24)] hover:bg-gold-soft' : 'border-2 border-gold/60 bg-transparent text-gold hover:border-gold hover:bg-gold/10';
  return <motion.a href={href} aria-label={ariaLabel} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} whileHover={{
    scale: 1.015
  }} whileTap={{
    scale: 0.985
  }} transition={{
    duration: 0.14,
    ease: [0.23, 1, 0.32, 1]
  }} className={`inline-flex items-center justify-center rounded-xl px-7 py-4 text-center text-base font-extrabold uppercase tracking-wide transition-colors duration-150 ease-smooth focus:outline-none focus:ring-4 focus:ring-gold/40 ${styles} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-344" data-mp="1ejhyhff3jiq8">
      {children}
    </motion.a>;
}